import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/src/stylus/app.styl'
import pl from 'vuetify/es5/locale/pl'

Vue.use(Vuetify, {
  theme: {
    primary: '#ec7200',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  },
  iconfont: 'md',
  lang: {
    locales: { pl },
    current: 'pl'
  }
})
